<template>
  <section class="content">
    <div class="callout callout-info" v-show="!offlineClass">
      <h4>Device Offline !</h4>
      <p>Some data of the device could not be set or query.</p>
    </div>

    <!--ping chart-->
    <!--from: chart chartJS AreaChart-->
    <div class="row">
      <div :class="offlineClass?'col-xs-12':'col-xs-12 device-offline-class'">
        <div class="box box-info">
          <div class="box-header with-border">
            <i class="fa fa-area-chart"></i>
            <span class="box-title">Network Status of Device</span>
          </div>
          <div class="box-body">
            <div class="chart">
              <canvas id="areaChart" style="height:250px"></canvas>
            </div>
          </div>
          <!-- /.box-body-->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
    <!-- / ping chart-->
    <!--Security State-->
    <div v-if="offlineClass" class="row security-state-row">
      <div class="col-xs-4 security-state-div">
        <button
          type="button"
          v-on:click="toSetSecurityState('Arm')"
          :class="deviceData.deviceState == 0?'btn btn-default security-state-btn1-active':'btn btn-default security-state-btn1'"
        >Arm</button>
      </div>
      <div class="col-xs-4 security-state-div">
        <button
          type="button"
          v-on:click="toSetSecurityState('Disarm')"
          :class="deviceData.deviceState == 2?'btn btn-default security-state-btn2-active':'btn btn-default security-state-btn2'"
        >Disarm</button>
      </div>
      <div class="col-xs-4 security-state-div">
        <button
          type="button"
          v-on:click="toSetSecurityState('Home Arm')"
          :class="deviceData.deviceState == 1?'btn btn-default security-state-btn3-active':'btn btn-default security-state-btn3'"
        >Home Arm</button>
      </div>
    </div>

    <div class="row security-state-row device-offline-class" v-else>
      <div class="col-xs-4 security-state-div">
        <button
          type="button"
          :class="deviceData.deviceState == 0?'btn btn-default security-state-btn1-active security-state-btn-disabled':'btn btn-default security-state-btn1 security-state-btn-disabled'"
        >Arm</button>
      </div>
      <div class="col-xs-4 security-state-div">
        <button
          type="button"
          :class="deviceData.deviceState == 2?'btn btn-default security-state-btn2-active security-state-btn-disabled':'btn btn-default security-state-btn2 security-state-btn-disabled'"
        >Disarm</button>
      </div>
      <div class="col-xs-4 security-state-div">
        <button
          type="button"
          :class="deviceData.deviceState == 1?'btn btn-default security-state-btn3-active security-state-btn-disabled':'btn btn-default security-state-btn3 security-state-btn-disabled'"
        >Home Arm</button>
      </div>
    </div>
    <!--Security State-->
    <!--Security State modal-dialog-->
    <div class="modal fade in" id="modal-security-state">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Set Security State</h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div class="firmware-version-update">
                <p>
                  Do you really want to set the security state as&nbsp;
                  <span
                    class="security-state-dialog-status"
                  >{{deviceCmd}}</span>&nbsp;?
                </p>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              aria-label="Cancel"
            >Cancel</button>
            <button type="button" class="btn btn-info" v-on:click="toSendCmd()">Yes, I do.</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Security State modal-dialog-->
    <!--device information table-->
    <div class="row">
      <!--left-->
      <div :class="offlineClass?'col-md-6 col-xs-12':'col-md-6 col-xs-12 device-offline-class'">
        <div class="box box-success">
          <table class="device-information-table">
            <tr>
              <th class="device-information-table-title">
                <i class="fa fa-at device-information-table-icon"></i>
                internet connection
              </th>
              <td class="device-information-table-content" v-if="deviceData.nettype === -1">
                <span>-</span>
              </td>
              <td class="device-information-table-content" v-else>
                <span v-if="deviceData.nettype === 0">LAN</span>
                <span v-else>Wifi</span>
              </td>
            </tr>
            <tr>
              <th class="device-information-table-title">
                <i class="fa fa-battery-three-quarters device-information-table-icon"></i>
                power situation
              </th>
              <td class="device-information-table-content" v-if="deviceData.power === -1">
                <span>-</span>
              </td>
              <td class="device-information-table-content" v-else>
                {{deviceData.power}}
                <span v-if="deviceData.ischarge">- charging</span>
                <span v-else>- battery</span>
              </td>
            </tr>
            <tr v-if="offlineClass">
              <th class="device-information-table-title">
                <i class="fa fa-signal device-information-table-icon"></i>
                sim card status
              </th>
              <td class="device-information-table-content" v-if="deviceData.sim === -1">
                <span>-</span>
              </td>
              <td class="device-information-table-content" v-else-if="deviceData.sim === 0">
                <span>have no card</span>
              </td>
              <td class="device-information-table-content" v-else-if="deviceData.sim === 1">
                <span>normal</span>
              </td>
              <td
                class="device-information-table-content sim-data-wrong"
                v-on:click="toCheckSimDetail"
                v-else
              >
                <span>
                  something wrong
                  <i class="fa fa-question-circle pull-right"></i>
                </span>
              </td>
            </tr>
            <tr v-else>
              <th class="device-information-table-title">
                <i class="fa fa-signal device-information-table-icon"></i>
                sim card status
              </th>
              <td class="device-information-table-content" v-if="deviceData.sim === -1">
                <span>-</span>
              </td>
              <td class="device-information-table-content" v-else-if="deviceData.sim === 0">
                <span>have no card</span>
              </td>
              <td class="device-information-table-content" v-else-if="deviceData.sim === 1">
                <span>normal</span>
              </td>
              <td class="device-information-table-content" v-else>
                <span>something wrong</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!--/ left-->
      <!--Sim Card Detail modal-dialog-->
      <div class="modal fade in" id="modal-sim-detail">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Sim Card Details</h4>
            </div>
            <div class="modal-body">
              <form class="form-horizontal">
                <table class="center sim-card-detail-table">
                  <tr>
                    <th colspan="2">AT+CSQ 信号质量:</th>
                    <td>{{simDetail.csq}}</td>
                  </tr>

                  <tr>
                    <th colspan="2">AT+CREG 网络注册信息:</th>
                    <td>{{simDetail.creg}}</td>
                  </tr>

                  <tr>
                    <th colspan="2">AT+CGSN imei:</th>
                    <td>{{simDetail.cgsn}}</td>
                  </tr>
                  <tr>
                    <th colspan="2">AT+CIMI imsi:</th>
                    <td>{{simDetail.cimi}}</td>
                  </tr>

                  <tr>
                    <th colspan="2">AT+CPIN cpin:</th>
                    <td>{{simDetail.cpin}}</td>
                  </tr>

                  <tr>
                    <th colspan="2">AT+COPS 运营商:</th>
                    <td>{{simDetail.cops}}</td>
                  </tr>
                </table>
              </form>
            </div>
            <div class="modal-footer">
              <!--<button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>-->
              <button
                type="button"
                class="btn btn-info"
                data-dismiss="modal"
                aria-label="Got it"
              >Got it</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--/ Sim Card Detail modal-dialog-->
      <!--right-->
      <div class="col-md-6 col-xs-12">
        <div class="box box-warning">
          <table class="device-information-table">
            <tr>
              <th class="device-information-table-title">
                <i class="fa fa-globe device-information-table-icon"></i>
                country/region
              </th>
              <td class="device-information-table-content" v-if="deviceData.ipaddress === -1">
                <span>-</span>
              </td>
              <td class="device-information-table-content" v-else>{{deviceData.ipaddress}}</td>
            </tr>
            <tr>
              <th class="device-information-table-title">
                <i class="fa fa-calendar device-information-table-icon"></i>
                activation time
              </th>
              <td
                class="device-information-table-content"
                v-if="deviceData.activetime > 0"
              >{{deviceData.activetime / 1000000 | formatDate}}</td>
              <td class="device-information-table-content" v-else>-</td>
            </tr>
            <tr>
              <th class="device-information-table-title">
                <i class="fa fa-gears (alias) device-information-table-icon"></i>
                firmware version
              </th>
              <td class="device-information-table-content" v-if="deviceData.version === -1">
                <span>-</span>
              </td>
              <td class="device-information-table-content" v-else>{{deviceData.version}}</td>
            </tr>
          </table>
        </div>
      </div>
      <!--/ right-->
    </div>
    <!-- / device information table-->
    <!--user list & plugin list-->
    <div class="row">
      <div class="col-md-6 col-xs-12">
        <div class="box box-danger">
          <table class="device-information-table table-hover">
            <thead>
              <tr>
                <th class="device-information-table-title" colspan="4">
                  <i class="fa fa-group (alias) device-information-table-icon"></i>member
                  <span class="pull-right" v-if="isShowUserEmptyList">total: 0</span>
                  <span class="pull-right" v-else>total: {{deviceData.totaluses}}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isShowUserEmptyList">
                <td colspan="4" class="aboutdevice-user-list">
                  <p class="aboutdevice-user-list-username">There is no member in this device.</p>
                </td>
              </tr>
              <tr v-for="item in deviceData.users" v-else>
                <td colspan="4" class="aboutdevice-user-list" v-on:click="toSearchUser(item.uid)">
                  <img
                    class="aboutdevice-user-list-img"
                    v-if="item.photo == ''"
                    src="../../../static/img/img_device_user_default.png"
                  >
                  <img
                    class="aboutdevice-user-list-img"
                    v-else
                    v-bind:src="'https://d.din.bz/'+item.photo"
                  >
                  <span class="aboutdevice-user-list-username">{{item.uid}}</span>
                  <span
                    class="aboutdevice-user-list-authority pull-right"
                    v-if="item.permission === 30"
                  >admin</span>
                  <span
                    class="aboutdevice-user-list-authority pull-right"
                    v-else-if="item.permission === 20"
                  >user</span>
                  <span class="aboutdevice-user-list-authority pull-right" v-else>guest</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-md-6 col-xs-12">
        <div class="box box-info">
          <table class="device-information-table table-hover">
            <thead>
              <tr>
                <th class="device-information-table-title" colspan="4">
                  <i class="fa fa-cubes device-information-table-icon"></i>accessory
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isShowPluginEmptyList">
                <td colspan="4" class="aboutdevice-user-list">
                  <p class="aboutdevice-user-list-username">There is no plugin in this device.</p>
                </td>
              </tr>
              <tr v-for="item in deviceData.plugin" v-else>
                <td colspan="4" class="aboutdevice-user-list" v-on:click="toSearchPlugin(item.id)">
                  <img
                    class="aboutdevice-user-list-img"
                    v-if="!item.icon"
                    src="../../../static/img/accessoryicon/icon_eventlist_others.svg"
                  >
                  <img class="aboutdevice-user-list-img" :src="item.icon" v-else>
                  <span class="aboutdevice-user-list-username">{{item.prename}}</span>
                  <span class="aboutdevice-user-list-authority pull-right">{{item.id}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--/ user list & plugin list-->
    </div>
  </section>
</template>
<script>
import { servers } from '../../demo'
import api from '../../api'
import utils from '../../utils'
import global from '../Global.vue'
import Chart from '../../../static/js/plugins/chartjs/Chart.min.js'
import config from '../../config'

export default {
  name: 'AboutDevice',
  data () {
    return {
      servers,
      deviceData: {
        nettype: -1,
        power: -1,
        sim: -1,
        ipaddress: -1,
        version: -1
      },
      simDetail: {
        csq: -1,
        creg: -1,
        cgsn: -1,
        cimi: -1,
        cpin: -1,
        cops: -1
      },
      eventlistData: [],
      deviceCmd: '',
      offlineClass: true,
      isShowUserEmptyList: false,
      isShowPluginEmptyList: false
    }
  },
  async mounted () {
    var params = new URLSearchParams()
    var jsons = {
      appid: this.$route.query.appid,
      deviceid: this.$route.query.deviceid
    }
    params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
    if (window.localStorage) {
      params.append('token', this.$router.app.$store.state.user.token)
    }
    this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
    await this.fetchDeviceDetail(params)
    this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
  },
  methods: {
    toCheckSimDetail () {
      if (!utils.checkIsAppAdmin) {
        return
      }
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        deviceid: this.$route.query.deviceid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      api.request('post', '/getdevicesimdata?_type=json', params)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              this.simDetail = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
              console.log(this.simDetail)
              window.jQuery('#modal-sim-detail').modal('show')
            }
          }
        })
    },
    toSetSecurityState (cmd) {
      if (!this.offlineClass) {
        return
      }
      this.deviceCmd = cmd
      window.jQuery('#modal-security-state').modal('show')
    },
    toSendCmd () {
      var cmd = this.deviceCmd
      var type = 'TASK_HOMEARM'
      if (cmd === 'Arm') {
        type = 'TASK_ARM'
        this.deviceData.deviceState = 0
      } else if (cmd === 'Disarm') {
        type = 'TASK_DISARM'
        this.deviceData.deviceState = 2
      } else {
        type = 'TASK_HOMEARM'
        this.deviceData.deviceState = 1
      }

      var params = new URLSearchParams()
      var jsons = {
        messageid: utils.getMessageId(),
        devtoken: this.deviceData.devicetoken,
        cmd: type,
        userid: ''
      }
      params.append('json', JSON.stringify(jsons))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
            alert('fail')
          } else {
            this.deviceState = cmd
            window.jQuery('#modal-security-state').modal('hide')
          }
        })
    },
    initPingData (datas) {
      var lables = []
      for (var i = 0; i < datas.length; i++) {
        lables.push('')
      }
      // Get context with jQuery - using jQuery's .get() method.
      var areaChartCanvas = window.jQuery('#areaChart').get(0).getContext('2d')
      // This will get the first returned node in the jQuery collection.
      var areaChart = new Chart(areaChartCanvas)

      var areaChartData = {
        labels: lables,
        datasets: [
          {
            label: 'Digital Goods',
            fillColor: 'rgba(60,141,188,0.9)',
            strokeColor: 'rgba(60,141,188,0.8)',
            pointColor: '#3b8bba',
            pointStrokeColor: 'rgba(60,141,188,1)',
            pointHighlightFill: '#fff',
            pointHighlightStroke: 'rgba(60,141,188,1)',
            data: datas
          }
        ]
      }

      var areaChartOptions = {
        //          Boolean - If we should show the scale at all
        showScale: true,
        //          Boolean - Whether grid lines are shown across the chart
        scaleShowGridLines: false,
        //          String - Colour of the grid lines
        scaleGridLineColor: 'rgba(0,0,0,.05)',
        //          Number - Width of the grid lines
        scaleGridLineWidth: 1,
        //          Boolean - Whether to show horizontal lines (except X axis)
        scaleShowHorizontalLines: true,
        //          Boolean - Whether to show vertical lines (except Y axis)
        scaleShowVerticalLines: true,
        //          Boolean - Whether the line is curved between points
        bezierCurve: true,
        //          Number - Tension of the bezier curve between points
        bezierCurveTension: 0.3,
        //          Boolean - Whether to show a dot for each point
        pointDot: false,
        //          Number - Radius of each point dot in pixels
        pointDotRadius: 4,
        //          Number - Pixel width of point dot stroke
        pointDotStrokeWidth: 1,
        //          Number - amount extra to add to the radius to cater for hit detection outside the drawn point
        pointHitDetectionRadius: 20,
        //          Boolean - Whether to show a stroke for datasets
        datasetStroke: true,
        //          Number - Pixel width of dataset stroke
        datasetStrokeWidth: 2,
        //          Boolean - Whether to fill the dataset with a color
        datasetFill: true,
        //          String - A legend template
        legendTemplate: '<ul class=\'<%=name.toLowerCase()%>-legend\'><% for (var i=0; i<datasets.length; i++){%><li><span style=\'background-color :< %=datasets[i].lineColor%>\'></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>',
        //          Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
        maintainAspectRatio: true,
        //          Boolean - whether to make the chart responsive to window resizing
        responsive: true
      }

      //        Create the line chart
      areaChart.Line(areaChartData, areaChartOptions)
    },
    toSearchUser (uid) {
      this.$router.push('/deviceuser?appid=' + this.$route.query.appid +
        '&appname=' + this.$route.query.appname +
        '&key=' + uid)
      //        this.$router.push('/deviceuser?appid=' + this.$route.query.appid +
      //          '&appname=' + this.$route.query.appname)
    },
    toSearchPlugin (id) {
      this.$router.push('/accessory?appid=' + this.$route.query.appid +
        '&appname=' + this.$route.query.appname +
        '&key=' + id)
    },
    async fetchDeviceDetail (params) {
      const response = await api.request('post', '/getdevicesdetail?_type=json', params)

      if (!response) return

      var data = response.data
      /* Checking if error object was returned from the server */
      if (data.Status !== 1) {
      } else {
        if (data.Result) {
          this.deviceData = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
          var datas = []
          if (!utils.isEmpty(this.deviceData.pingdata)) {
            for (var i = 0; i < this.deviceData.pingdata.length && i < 10; i++) {
              datas.push(this.deviceData.pingdata[i].pinduration / 1000000)
            }
          }
          for (var j = 0; j < this.deviceData.plugin.length; j++) {
            if (this.deviceData.plugin[j].name === '') {
              this.deviceData.plugin[j].prename = '( Pre-paired Accessory )'
            } else {
              this.deviceData.plugin[j].prename = this.deviceData.plugin[j].name
            }
            this.deviceData.plugin[j].icon = utils.getPluginIconByCatAndSub(this.deviceData.plugin[j].cat, this.deviceData.plugin[j].sub)
          }
          if (this.deviceData.online === 1) {
            this.offlineClass = true
          } else {
            this.offlineClass = false
          }
          if (utils.isEmpty(this.deviceData.users) || this.deviceData.users.length <= 0) {
            this.isShowUserEmptyList = true
          } else {
            this.isShowUserEmptyList = false
          }
          if (this.deviceData.plugin.length <= 0) {
            this.isShowPluginEmptyList = true
          } else {
            this.isShowPluginEmptyList = false
          }
          this.initPingData(datas)
          this.$store.commit('SET_DEVICETOKEN', this.deviceData.devicetoken)
        }
      }
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return utils.formatDate(date, 'yyyy-MM-dd')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// AboutDevice.vue?5476b1e2